import apiService from './apiService';

export interface Customer {
  id: string;
  name: string;
  email?: string;
  phone?: string;
  address?: string;
  companyId: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

class CustomerService {
  /**
   * Get all customers
   */
  async getAllCustomers(params?: {
    page?: number;
    limit?: number;
    search?: string;
    isActive?: boolean;
  }): Promise<Customer[]> {
    const response = await apiService.getCustomers({
      ...params,
      limit: params?.limit || 1000 // Get all customers by default
    });
    // Backend returns { customers, pagination }
    return response.customers || response.data || [];
  }

  /**
   * Get customer by ID
   */
  async getCustomerById(id: string): Promise<Customer> {
    const response = await apiService.getCustomerByIdV2(id);
    return response.data;
  }
}

export default new CustomerService();